<template>

  <div class="item-container" @click="handleClick">
    <div class="item" :class="!canuse ? 'nouse' : ''">
      <span class="f-l icon" v-if="itemIcon" :style="{backgroundImage: 'url('+itemIcon+')'}"></span>
      <span class="f-l name">{{name}}</span>
      <span class="f-r iconfont" v-if="rightIcon==='true'">&#xe646;</span>
      <span class="f-r sub-name">{{subName}}</span>
    </div>
    <div class="sub-container" v-if="subItem.length !== 0">
      <div 
        class="sub-item" 
        ref="subBtn" 
        :class="addBorder() ? '' : 'itemN'" 
        v-for="(item, i) in subItem"
        :style="{backgroundColor: addBackColor && i===5 ? '#000000' : 'transparent', color: addBackColor && i===5 ? '#ffffff' : '#000000'}"
        :key="i">
        {{item}}
      </div>
    </div>
  </div>
   
</template>
<script>
export default {
  name: 'MenuList',
  props: {
    name: String,
    subName: String,
    itemIcon: String,
    subItem: {
      type: Array,
      default () {
        return []
      }
    },
    canuse: {
      type: Boolean,
      default () {
        return true
      }
    },
    rightIcon: {
      type: String,
      default () {
        return 'true'
      }
    }
  },
  data () {
    return {
      subNameB: this.subItem
    }
  },
  methods: {
    handleClick () {
      this.$emit('handleClick', '')
    },
    addBorder () {
      return (this.subItem.length === 3 && this.subItem[2] !== '') || (this.subItem.length === 6 && this.subItem[5] !== '')
    },
    addBackColor () {
      return (this.subItem.length === 6 && this.subItem[5] !== '')
    }
  },
  watch: {
    subName: {
      handler (cval, oval) {
        if (!cval) return
        this.subNameB = cval
      },
      deep: true
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~styles/mixins.styl"
.item-container
  border-bottom 1px solid #ededed
  .item
    .icon
      display inline-block
      width 20px
      height 20px
      backgroundImg()
      margin-top 15px
      margin-right 8px
    height 50px
    line-height 50px
    color #333333
    font-size 14px
    .sub-name
      font-size 12px
      padding-right 8px
  .nouse
    color #999999
  .sub-container
    rowSpaceBetween()
    flex-wrap wrap
    .sub-item
      width 98px;
      height 35px;
      line-height 35px
      text-align center
      font-size 16px
      color #666666
      font-family Arial
      border 1px solid #ededed
      border-radius 5px
      margin-bottom 16px
    .itemN:last-child
      border none
</style>


// WEBPACK FOOTER //
// src/components/MenuList/MenuList.vue